import React, { useState } from 'react'
import { Alert, Col, Container, Row } from 'react-bootstrap';
import MenuButton from '../../../app/styles/components/MenuButton';
import { useSelector } from 'react-redux';
import { selectIsMobileRoute } from '../../mobile/mobileSlice';
import DietaryNeedsGolsForm from '../DietaryNeedsGolsForm';
import { useLocation, useNavigate } from 'react-router-dom';

export default function DietaryGoalsMobileWrapper() {
    const location = useLocation();
    const navigate = useNavigate();
    const AppURL = useSelector(selectIsMobileRoute);
    const [errorMsg, setErrorMsg] = useState('');
    const urlParams = AppURL ? `/?${AppURL}` : '';

    const handleSecondAccordian = () => {
        navigate(`/my-account/edit-account${urlParams}`);
    }

    return (
        <Container fluid="lg">
            <Row>
                <Col xs={2} className='p-0 px-2 pt-2'>
                    <MenuButton redirectURL={`/my-account/edit-account${urlParams}`} urlState={location.state ? location.state : {}} />
                </Col>
                <Col xs={10} className='p-0 px-3 d-flex align-items-center justify-content-end'>
                    <span className="text-uppercase fw-400 fs-32px font-league-gothic">Dietary Needs & Gols</span>
                </Col>
            </Row>
            <div className='mx-2 my-4 accordion accordion-flush'>
                <div className='border mb-3 bg-light text-dark accordion-item'>
                    <div className='accordion-collapse collapse show'>
                        <div className='p-4 mt-md-3 accordion-body'>
                            <DietaryNeedsGolsForm handleSecondAccordian={handleSecondAccordian} setErrorMsg={setErrorMsg} />
                            {errorMsg &&
                                <Alert className='mb-4' variant='danger'>{errorMsg}</Alert>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}